export default "__VITE_ASSET__Dhxcubm7__"